<template>
  <!-- 填充式布局组件 -->
  <div
    ref="container"
    class="container-component"
    :style="'--paddingVal:' + paddingVal + ';--paddingRight:' + (paddingVal != 0 ? paddingVal : '20px')"
  >
    <div class="container-full">
      <div v-if="$slots.header" :class="{ 'container-full__header': true, 'button-header': buttonHeader }" ref="header">
        <slot name="header" />
      </div>
      <div class="container-full__body" ref="wrapper">
        <div class="container-full__body-wrapper-inner" :style="{ backgroundColor: bodyColor }">
          <slot />
        </div>
      </div>
      <div v-if="$slots.footer" :class="{ 'container-full__footer': true, 'button-footer': buttonFooter }" ref="footer">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'container-full-scroll',
  props: {
    // body区域背景色
    bodyColor: {
      type: String,
      default: '#ffffff'
    },
    // padding值
    paddingVal: {
      type: String,
      default: '20px'
    },
    // 默认 顶部按钮组样式
    buttonHeader: {
      type: Boolean,
      default: true
    },
    // 默认 底部按钮组样式
    buttonFooter: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="scss" scoped>
.container-component {
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;

  .container-full {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;

    &__header {
      margin-bottom: 10px;

      &.button-header {
        text-align: right;
        height: 60px;
        line-height: 60px;
        background: #ffffff;
        box-shadow: 0px 1px 2px 0px rgba(12, 0, 51, 0.1);
        border-radius: 4px;
        padding-right: var(--paddingRight);
      }
    }
    &__footer {
      margin-top: 10px;

      &.button-footer {
        text-align: right;
        height: 60px;
        line-height: 60px;
        background: #ffffff;
        box-shadow: 0px 1px 2px 0px rgba(12, 0, 51, 0.1);
        border-radius: 4px;
        padding-right: var(--paddingRight);
      }
    }

    .container-full__body {
      flex-grow: 1;
      overflow: hidden;
      position: relative;
      .container-full__body-wrapper-inner {
        position: relative;
        height: 100%;
        padding: var(--paddingVal);
        box-shadow: 0px 1px 2px 0px rgba(12, 0, 51, 0.1);
        border-radius: 4px;
        overflow: hidden;
        overflow-y: auto;

        &::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }
        &::-webkit-scrollbar-thumb {
          background-color: #999999;
          background-clip: padding-box;
          border-radius: 8px;
        }
        &::-webkit-scrollbar-thumb:hover {
          background-color: #999999;
        }
        &::-webkit-scrollbar-thumb:active {
          background-color: #999999;
        }
        &::-webkit-scrollbar-track {
          background-color: #f5f5f5;
        }
      }
    }
  }
}
</style>
